import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    width="34"
    height="36"
    viewBox="0 0 34 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="file">
    <path
      d="M21.1868 0H4.67336C3.5162 0 2.57812 0.938073 2.57812 2.09524V32.127C2.57812 33.2842 3.5162 34.2222 4.67336 34.2222H28.7686C29.9258 34.2222 30.8638 33.2842 30.8638 32.127V9.31176C30.8638 8.73813 30.6287 8.18958 30.2132 7.7941L22.6314 0.577574C22.2418 0.206794 21.7246 0 21.1868 0Z"
      fill="#C7BCE4"></path>
  </svg>
);

const FileIcon = (props) => <Icon component={svg} {...props} />;

export default FileIcon;
